import React, { useState, useEffect } from "react";
import { TextField, Button, Container, Typography } from "@mui/material";
import { styled } from "@mui/system";
import "./Welcome.css";

const StyledContainer = styled(Container)`
  margin-top: 20px;
`;

const StyledTextField = styled(TextField)(({ theme, error }) => ({
  marginTop: "16px",
  width: "100%",
  ...(error && {
    animation: "shake 0.35s",
  }),
}));

const StyledButton = styled(Button)`
  margin-top: 16px;
  display: block;
`;

const Welcome = ({ onSaveCredentials, validCredentials }) => {
  const [url, setUrl] = useState(localStorage.getItem("tandoorUrl") || "");
  const [token, setToken] = useState(localStorage.getItem("apiToken") || "");
  const [error, setError] = useState(false);

  useEffect(() => {
    setError(!validCredentials);
  }, [validCredentials]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (url === "" || token === "") {
      console.log("Error: Missing credentials");
      // Reset error state to trigger re-animation
      setError(false);
      setTimeout(() => setError(true), 3);
    } else {
      console.log("Trying credentials...");
      let result = onSaveCredentials(url, token);
      if (!result) {
        console.log("Error: Invalid credentials");
        setError(false);
        setTimeout(() => setError(true), 10);
      }
    }
  };

  return (
    <StyledContainer maxWidth="sm">
      <Typography variant="h4" gutterBottom>
        Welcome to Sous-Chef for Tandoor!
      </Typography>
      <form onSubmit={handleSubmit}>
        <StyledTextField
          error={error}
          helperText={
            error ? "Please enter a valid Tandoor URL & API Token" : ""
          }
          label="Self-hosted Tandoor URL"
          type="text"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          variant="outlined"
        />
        <StyledTextField
          error={error}
          helperText={error && "Please enter a valid Tandoor URL & API Token"}
          label="API Token"
          type="text"
          value={token}
          onChange={(e) => setToken(e.target.value)}
          variant="outlined"
        />
        <StyledButton type="submit" color="primary" variant="contained">
          Submit
        </StyledButton>
      </form>
    </StyledContainer>
  );
};

export default Welcome;
